import { type JSX, useState } from "react";
import { useMutation } from "urql";
import t from "../../shared/translations";
import { graphql } from "../gql";
import type { ITask, ITaskVariant } from "./query";
import { Button } from "./stylings";

interface Props {
    task: ITask;
    variant: ITaskVariant;
    invert: boolean;
}

const mutation = graphql(`
    mutation AppStart24HoursMutation($taskId: ID!, $variantId: ID!) {
        start24HoursTask(taskId: $taskId, variantId: $variantId) {
            error
            submittedTask {
                id
                task {
                    id
                }
            }
        }
    }
`);

function Start24Hours({ task, variant, invert }: Props): JSX.Element {
    const [startResult, executeMutation] = useMutation(mutation);
    const [error, setError] = useState("");

    const start = async () => {
        if (startResult.fetching) {
            return;
        }
        const result = await executeMutation({ taskId: task.id, variantId: variant.id });
        if (result.error) {
            console.error(result.error);
            setError("ERROR");
        } else if (result.data.start24HoursTask?.error) {
            console.error(result.data.start24HoursTask.error);
            setError(result.data.start24HoursTask.error);
        }
    };

    return (
        <section>
            <div className="text-center">
                <Button $invert={invert} type="button" onClick={start} disabled={startResult.fetching}>
                    {t("player.task.button-start-hours")}
                </Button>
            </div>
            {error && <p className="text-center">{error}</p>}
        </section>
    );
}

export default Start24Hours;
